import React from 'react'
import { ColorPickerControl } from '../../controls/color-picker/color-picker-control'
import { useCurrentTheme } from 'src/editor/layout/sidebar/website-styles-settings/hooks/useCurrentTheme'
import { WebsiteThemeInterface } from 'src/shared/types/website-settings-types'

interface ColorPickerGroupProps<
  ElementKey extends keyof WebsiteThemeInterface,
  PropertyKey extends keyof WebsiteThemeInterface[ElementKey],
> {
  colorKeys: {
    key: WebsiteThemeInterface[ElementKey][PropertyKey] extends string
      ? PropertyKey
      : never
    title: string
  }[]
  elementKey: ElementKey
}

export const ColorPickerGroup = <
  ElementKey extends keyof WebsiteThemeInterface,
  PropertyKey extends keyof WebsiteThemeInterface[ElementKey],
>({
  colorKeys,
  elementKey,
}: ColorPickerGroupProps<ElementKey, PropertyKey>) => {
  const { currentTheme, onUpdate } = useCurrentTheme()
  const theme = currentTheme as Record<ElementKey, Record<PropertyKey, string>>
  return (
    <>
      {colorKeys.map(({ key, title }) => (
        <ColorPickerControl
          update={value =>
            onUpdate({
              [elementKey]: {
                ...theme?.[elementKey],
                [key]: value,
              },
            })
          }
          color={theme?.[elementKey]?.[key]}
          label={title}
          key={String(key)}
        />
      ))}
    </>
  )
}
